export const isValidNumber = (num: number): boolean => {
  if (!num && num !== 0) {
    return false;
  }
  return true;
};
